(() => {
  const NEW_TAB_REL = ["noopener", "noreferrer"];

  const shouldOpenInNewTab = (link) => {
    const href = link.getAttribute("href");
    if (!href || href.startsWith("#")) return false;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch {
      return false;
    }

    if (!["http:", "https:"].includes(url.protocol)) return false;

    const isExternal = url.hostname !== window.location.hostname;
    const isPdf = url.pathname.toLowerCase().endsWith(".pdf");

    return isExternal || isPdf;
  };

  const updateLink = (link) => {
    if (!shouldOpenInNewTab(link)) return;

    link.target = "_blank";

    const rel = new Set(
      (link.getAttribute("rel") || "").split(/\s+/).filter(Boolean),
    );
    NEW_TAB_REL.forEach((value) => rel.add(value));
    link.setAttribute("rel", [...rel].join(" "));
  };

  const updateLinks = (root) => {
    if (root instanceof HTMLAnchorElement) updateLink(root);
    root.querySelectorAll?.("a[href]").forEach(updateLink);
  };

  const init = () => {
    updateLinks(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes") {
          if (mutation.target instanceof HTMLAnchorElement) {
            updateLink(mutation.target);
          }
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) updateLinks(node);
        });
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["href"],
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
